import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AllLabels } from '../constants/app.constants';
import { CommunicationService } from '../services/communication.service';
import { LocalStorageService } from '../services/local-storage.service';
import { UserService } from '../services/user.service';
import { EnvironmentService } from '../services/environment.service';

@Component({
  selector: 'app-dashboard',
  styleUrls: ['./dashboard.component.scss'],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {
  appLabels: {
    [key: string]: string;
  };
  isLogin: boolean;
  showPrivacyPolicyLink: boolean;

  constructor(
    private communicationService: CommunicationService,
    private localStorageService: LocalStorageService,
    private userService: UserService,
    private route: Router,
    private environmentService: EnvironmentService
  ) {
    this.appLabels = AllLabels.app;

    // todo: this is an ugly fix for technician_id being string in inubit, integer/number in .NET. improve!
    this.isLogin = !(
      this.localStorageService.getItem('technician_id') &&
      (this.localStorageService.getItem('technician_id').length > 0 || this.localStorageService.getItem('technician_id') > 0)
    );

    this.userService.updateUserData.subscribe(() => {
      if (this.userService.userDetails === null) {
        this.isLogin = true;
        this.communicationService.dashboardLogoClick(false);
        return;
      }
      this.isLogin = false;
    });
  }

  ngOnInit(): void {
    if (this.localStorageService.getItem('role') === 'customer') {
      this.route.navigate(['/panel']);
    }
    this.showPrivacyPolicyLink = this.environmentService.privacyPolicy?.showPrivacyPolicyLink;
  }

  showLoginForm(): void {
    this.communicationService.dashboardLogoClick(true);
  }

  openImprint(): void {
    const impressumRoute = this.environmentService.impressumRoute ?? '/impressum';

    if (this.isValidUrl(impressumRoute)) {
      window.open(impressumRoute);
      return;
    }

    this.route.navigate([impressumRoute]);
  }

  openPrivacyPolicy(): void {
    const privacyPolicyLink = this.environmentService.privacyPolicy?.privacyPolicyLink || '';
    if (privacyPolicyLink) {
      window.open(privacyPolicyLink);
    } else {
      this.route.navigate(['/privacy-policy']);
    }
  }

  private isValidUrl(value: string) {
    let url: URL;

    try {
      url = new URL(value);
    } catch (_) {
      return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
  }
}
